import { React, useContext } from "react";
import Request from "./Request";
import { GlobalInfo } from "../App";
export default function Achivements(props) {
  const { val, acc, getupdate } = useContext(GlobalInfo);
  return (
    <div
      className=""
      id="back"
      style={{
        backgroundImage: "url(" + "p.jpg" + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        paddingTop: 30,
      }}
    >
      <center>
        <h2>
          <b>Happy Faces</b>
        </h2>
        <div className="row">
          {props.e.map((element) => {
            return (
              <>
                {element.completed === true ? (
                  <div className="col-md-4" key={element.description}>
                    {" "}
                    <Request cat={element} />{" "}
                  </div>
                ) : (
                  <></>
                )}
              </>
            );
          })}
        </div>
      </center>
    </div>
  );
}
